export default __webpack_public_path__ + "static/media/PasswordGeneratorImg.b351ed98.png";